// Pure helpers for highlight-to-edit selection math (kept side-effect-free for unit testing).

/**
 * Count how many non-overlapping occurrences of `needle` end at or before `offset` within
 * `text`. Used to disambiguate which occurrence of a highlighted phrase the user selected so
 * the backend can target the right span. Returns a 0-indexed occurrence number.
 */
export function occurrenceBeforeOffset(text: string, offset: number, needle: string): number {
  if (!needle) return 0;
  let count = 0;
  let idx = text.indexOf(needle);
  while (idx !== -1 && idx < offset) {
    count += 1;
    idx = text.indexOf(needle, idx + needle.length);
  }
  return Math.max(0, count - 1);
}

/** Clamp a popover's (top,left) so it stays within the container's [0,maxW]×[0,maxH] box. */
export function clampPopover(
  top: number,
  left: number,
  containerW: number,
  containerH: number,
  popW: number,
  popH: number,
): { top: number; left: number } {
  const clampedLeft = Math.max(0, Math.min(left, Math.max(0, containerW - popW)));
  const clampedTop = Math.max(0, Math.min(top, Math.max(0, containerH - popH)));
  return { top: clampedTop, left: clampedLeft };
}

/** Whether a selection string is meaningful enough to offer an edit popover for. */
export function isUsableSelection(text: string | null | undefined, minLen = 2): boolean {
  return !!text && text.trim().length >= minLen;
}
